import { Routes, Route } from "react-router";
import PackagesMain from "Modules/packages/views/main";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Views
import PackageOverview from "Modules/packages/views/overview";

const PackagesViews = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "rol") && <Route path="list" element={<PackagesMain />} />}
                {HasPermission(user, "rol") && <Route path="overview/:id" element={<PackageOverview />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default PackagesViews;